export const SHOPPING_CART_INIT_BY_PAYMENT = 'SHOPPING_CART_INIT_BY_PAYMENT';
